module.exports = __webpack_public_path__ + "img/mi-support.8c3b2f7c.svg";